<template>
  <Breadcrumb :home="home" :model="items" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Breadcrumb from 'primevue/breadcrumb'

export default defineComponent({
  components: { Breadcrumb },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const home = { icon: 'pi pi-home', to: '/' }

    return { home }
  }
})
</script>

<style lang="scss" scoped>
.p-breadcrumb {
  border: none;
  padding: 0;
}
</style>
